import { render, staticRenderFns } from "./DepositWithdrawal.vue?vue&type=template&id=1c6feefb&"
import script from "./DepositWithdrawal.vue?vue&type=script&lang=js&"
export * from "./DepositWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./DepositWithdrawal.vue?vue&type=style&index=0&id=1c6feefb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports